import React, { useState, useEffect } from "react";
import "./landing.css";
import { Link } from "react-router-dom";
import Marketplace from "../../assets/img/icons/icons/Marketplace.svg";
import My_Network from "../../assets/img/icons/icons/My_Network.svg";
import Jobs from "../../assets/img/icons/icons/Jobs.svg";
import Services from "../../assets/img/icons/icons/Services.svg";
import RealEstate from "../../assets/img/icons/icons/real-estate.svg";
import Business from "../../assets/img/icons/icons/Business.svg";
import Dating from "../../assets/img/icons/icons/Dating.svg";
import events from "../../assets/img/icons/icons/events.svg";
import Articles from "../../assets/img/icons/icons/Articles.svg";
import Groups_Pages from "../../assets/img/icons/icons/Groups_Pages.svg";
import fonofavicon from "../../assets/img/icons/fonofavicon1.png";
import {
  FormGroup,
  Input,
  Card,
  CardBody,
  CardText,
  CardHeader,
} from "reactstrap";
import axios from "axios";
import { connect } from "react-redux";
import Avatar from "react-avatar";
import { userActions, failure } from "../../redux/actions/userActions";
import Footer from "../layout/footer";
import image from "../../assets/img/icons/common/NoPreview.png";
import "../../index.css";
import fetchApi from "../../common/fetchApi";
import api from "../../routes/api";
import Loading from "../layout/loader";
import swal from "sweetalert";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const withNavigate = (Component) => (props) => {
  const navigate = useNavigate();
  return <Component {...props} navigate={navigate} />;
};
class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.props.logout();
    this.state = {
      fields: {
        email: "",
        password: "",
      },
      errors: {},
      recentData: [],
      inputError: "",
      forgetEmail: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
  }
  handleChange(e) {
    this.setState({ inputError: "" });
    this.props.logInError("");
    const { name, value } = e.target;

    this.setState((prevState) => ({
      ...prevState,
      fields: {
        ...this.state.fields,
        [name]: value,
      },
    }));
  }
  validateForm = async () => {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "*Please enter your email-ID.";
    }
    if (typeof fields["email"] !== "undefined") {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(fields["email"])) {
        formIsValid = false;
        errors["email"] = "*Please enter valid email-ID.";
      }
    }
    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "*Please enter your password.";
    }
    if (typeof fields["password"] !== "undefined") {
      if (
        !fields["password"].match(
          /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/
        )
      ) {
        formIsValid = false;
        errors["password"] = "*Please enter secure and strong password.";
      }
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  };
  getRecentLoginData = async () => {
    const result = await fetchApi({
      method: "GET",
      url: api.recentLoginData,
    });

    if (result.data === null) {
      return this.setState({ recentData: [] });
    }

    if (result.data.success) {
      this.setState({ recentData: result.data.data });
    } else {
      this.setState({ recentData: [] });
    }
  };
  componentDidMount() {
    this.getRecentLoginData();
  }

  submit = async (e) => {
    e.preventDefault();
    const { props, loadingFalse } = this;
    const { email, password } = this.state.fields;
    if (email === undefined || password === undefined) {
      return this.setState({ inputError: "Fill both fields" });
    }
    if (email.trim() === "" || password.trim() === "") {
      return this.setState({ inputError: "Fill both fields" });
    }

    if (email && password) {
      this.setState({
        loading: true,
      });

      const { navigate } = this.props;

      props.login(email.toLowerCase().trim(), password, props, loadingFalse);
    }
  };
  loadingFalse = () => {
    this.setState({ loading: false });
  };

  remove(e) {
    var array = [...this.state.recentData];
    var index = array.indexOf(e.target.value);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ recentData: array });
    }
  }

  onLogIn = (e) => {
    if (e.key === "Enter") {
      this.submit(e);
    }
  };

  onForgetEmailChange = (e) => {
    this.setState({
      forgetEmail: e.target.value,
    });
  };

  onFogetEmailSubmit = async () => {
    if (
      this.state.forgetEmail === "" ||
      !this.state.forgetEmail.includes("@")
    ) {
      console.log(window.location.origin);
      return console.log("forget error");
    }
    this.setState({
      loader: true,
    });
    const result = await fetchApi({
      method: "POST",
      url: api.forgetPassword,
      body: {
        email: this.state.forgetEmail.toLowerCase().trim(),
        base_url: window.location.origin,
      },
    });
    console.log(result);
    if (result && result.data.success) {
      this.setState({
        loader: false,
      });
      return swal(
        "Email Sent Successfully",
        "Please check your email inbox",
        "success"
      ).then(() => {
        this.props.navigation.navigate("/");
      });
    }
    if (result && result.data.success === false) {
      this.setState({
        loader: false,
      });
      return swal("Something Went Wrong", "Please try again");
    }
  };

  render() {
    return (
      <>
        {this.state.loading && <Loading />}
        <div className="custom-lp-home">
          <div className="container d-flex flex-column justify-content-between py-3">
            <div className="row">
              <div className="col-sm-5">
                <Link to="/">
                  <h5 className="display-5 text-white text-start logo-title logo-text">
                    Fonolive
                    <span className="module-logo">
                      <img width="100%" src={fonofavicon} />
                    </span>
                  </h5>
                </Link>
              </div>
              <div className="col-sm-7">
                <h6 className="text-danger">
                  in Beta...{"  "}
                  {/*<Link to="/old-fonolive" className="text-white">
                    Old Fonolive
                  </Link> */}
                </h6>
              </div>
            </div>
            <div className="align-items-center d-flex row">
              <div className="col-12 col-sm-7 col-lg-8 mb-3 mb-sm-0">
                <div className="d-flex gap-5 justify-content-center">
                  <div className="box_col_f d-inline">
                    <div className="d-flex">
                      <Link to="/marketplace" className="box_f1 lp1 d-inline">
                        <div className="img_f mx-auto">
                          <img width="100%" src={Marketplace} />
                        </div>
                        <p className="text-center">Marketplaces</p>
                      </Link>
                      <Link to="/my-network" className="box_f1 lp1 d-inline">
                        <div className="img_f mx-auto">
                          <img width="100%" src={My_Network} />
                        </div>
                        <p className="text-center">My Network</p>
                      </Link>
                    </div>
                    <div className="d-flex">
                      <Link to="/jobs" className="box_f1 lp2">
                        <div className="img_f mx-auto">
                          <img width="100%" src={Jobs} />
                        </div>
                        <p className="text-center">Jobs</p>
                      </Link>
                    </div>
                    <div className="d-flex">
                      <Link to="/services" className="box_f1 lp1 d-inline">
                        <div className="img_f mx-auto">
                          <img width="100%" src={Services} />
                        </div>
                        <p className="text-center">Services</p>
                      </Link>
                      <Link to="/groups" className="box_f1 lp1 d-inline">
                        <div className="img_f mx-auto">
                          <img width="100%" src={Groups_Pages} />
                        </div>
                        <p className="text-center">Groups</p>
                      </Link>
                    </div>
                    <div className="d-flex">
                      <Link to="/realState" className="box_f1 lp2">
                        <div className="img_f mx-auto">
                          <img width="100%" src={RealEstate} />
                        </div>
                        <p className="text-center">Real Estate</p>
                      </Link>
                    </div>
                  </div>
                  <div className="box_col_f d-inline">
                    <div className="d-flex">
                      <Link to="/pages" className="box_f2 pl1">
                        <div className="img_f mx-auto">
                          <img width="100%" src={Business} />
                        </div>
                        <p className="text-center">Pages</p>
                      </Link>
                    </div>
                    <div className="d-flex">
                      <Link to="/dating" className="box_f2 pl1">
                        <div className="img_f mx-auto">
                          <img width="100%" src={Dating} />
                        </div>
                        <p className="text-center">Meetup</p>
                      </Link>
                    </div>
                    <div className="d-flex">
                      <Link to="/events" className="box_f2 pl1">
                        <div className="img_f mx-auto">
                          <img width="100%" src={events} />
                        </div>
                        <p className="text-center">Events</p>
                      </Link>
                      <Link to="/article/all-article" className="box_f2 pl2">
                        <div className="img_f mx-auto">
                          <img width="100%" src={Articles} />
                        </div>
                        <p className="text-center">Articles</p>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-5 col-lg-4">
                <Card className="card shadow radius-15">
                  <CardBody className="auth-card-body">
                    <form>
                      <div className="row form">
                        <div className="col-md-12 col-12">
                          <FormGroup>
                            <Input
                              id="email"
                              placeholder="Enter email address"
                              type="email"
                              className=""
                              name="email"
                              value={this.state.fields.email}
                              onChange={(e) => this.handleChange(e)}
                            />
                            <div className="errorMsg">
                              {this.state.inputError}
                              {this.state.errors.email}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <FormGroup className="mb-0">
                            <Input
                              id="password"
                              placeholder="Enter Passsword"
                              type="password"
                              className=""
                              name="password"
                              value={this.state.fields.password}
                              onChange={(e) => this.handleChange(e)}
                              onKeyPress={(e) => this.onLogIn(e)}
                            />
                          </FormGroup>
                          <div className="errorMsg">
                            {this.props.errorMessage !== undefined &&
                              this.props.errorMessage}
                            {this.state.errors.password}
                          </div>
                        </div>

                        <div className="col-md-12 text-right">
                          <div className="d-inline-flex p-0 text-end">
                            <a
                              to="/"
                              className="poppins-500-13 color-blue-theme"
                              data-toggle="modal"
                              data-target="#exampleModal"
                            >
                              Forgot Password?
                            </a>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="row mt-3 form">
                      <div className="col-md-12">
                        <button className="fn-theme-btn" onClick={this.submit}>
                          Login
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <Link to="/signup" className="mobile-view-btn">
                          Create an account
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <Card className="text-center bg-white shadow signup-btn-box lp-signup-btn-box radius-15">
                  <CardBody>
                    <Link to="/signup">
                      <button className="btn-icon-only mb-2 btn btn-lg rounded-circle mybg1">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M29.1248 18.4999H18.4997V29.1251C18.4997 30.5052 17.38 31.6249 15.9998 31.6249C14.6197 31.6249 13.5 30.5052 13.5 29.1251V18.4999H2.87485C1.49469 18.4999 0.375 17.3802 0.375 16.0001C0.375 14.6199 1.49469 13.5002 2.87485 13.5002H13.5V2.87509C13.5 1.49493 14.6197 0.375244 15.9998 0.375244C17.38 0.375244 18.4997 1.49493 18.4997 2.87509V13.5002H29.1248C30.505 13.5002 31.6247 14.6199 31.6247 16.0001C31.6247 17.3802 30.505 18.4999 29.1248 18.4999Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                    </Link>
                    <Link to="/signup" className="d-block">
                      Create an account
                    </Link>
                  </CardBody>
                </Card>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <h3 className="m-0 pt-4 text-center text-market-footer">
                  SOCIAL MARKETPLACE
                </h3>
                <div className="m-0 pt-4 text-center text-market-footer">
                  <span>
                    <a href="https://play.google.com/store/apps/details?id=com.fonolive">
                      <img
                        src="/google-play-badge.png"
                        height={115}
                        width={300}
                      />
                    </a>
                  </span>
                  <span>
                    <a href="https://apps.apple.com/us/app/fonolive-social-marketplace/id6450934952">
                      <img
                        src="/apple-store-badge.png"
                        height={80}
                        width={300}
                      />
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*-------------------Forget Password Modal------------------------*/}
        <div
          className="modal fade fn-modal"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header mycolor">
                <h5 className="modal-title" id="exampleModalLabel"></h5>
                <button
                  type="button"
                  className="close mybtn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M34.025 38.9748C35.3919 40.3417 37.6082 40.3417 38.9752 38.9748C40.3416 37.6079 40.3416 35.3916 38.9752 34.0247L24.9503 19.9999L38.9747 5.97517C40.3416 4.6083 40.3416 2.39215 38.9747 1.02524C37.6082 -0.341636 35.3919 -0.341636 34.025 1.02524L20.0001 15.0502L5.9752 1.02519C4.60828 -0.34173 2.39212 -0.34173 1.02524 1.02519C-0.341685 2.39206 -0.341685 4.60821 1.02524 5.97513L15.05 19.9999L1.02519 34.0247C-0.341731 35.3916 -0.341731 37.6079 1.02519 38.9748C2.39207 40.3417 4.60823 40.3417 5.97516 38.9748L20.0001 24.95L34.025 38.9748Z"
                      fill="#10182B"
                    />
                  </svg>
                </button>
              </div>
              <div className="modal-body mycolor pb-5">
                <p className="text-center poppins">
                  Please enter registered email address.
                </p>
                <p className="text-center poppins">
                  Check your mail or spam box for the reset link.
                </p>

                <div className="row mt-3 mb-5  justify-content-center">
                  <div className="col-lg-6">
                    <Card className="radius-15">
                      <CardBody className="radius-15 auth-card-body">
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <FormGroup>
                              <Input
                                placeholder="Enter email address"
                                className=""
                                onChange={(e) => this.onForgetEmailChange(e)}
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <button
                              className="fn-theme-btn"
                              onClick={this.onFogetEmailSubmit}
                            >
                              Submit
                            </button>
                            {/* <a href="#" className="d-block mt-3 text-center text-dark">Resend</a> */}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <Toaster />
      </>
    );
  }
}

const mapState = (state) => ({
  // const { loggingIn } = state.authentication;
  // return { loggingIn };
  errorMessage: state.authentication.error,
  loading: state.loading,
});

const actionCreators = {
  login: userActions.login,
  logout: userActions.logout,
  logInError: failure,
};

const RecentChats = () => {
  const [state, setState] = useState({
    recentData: [],
  });

  useEffect(() => {
    getRecentData();
  }, []);

  const getRecentData = async () => {
    const result = await axios({
      method: "GET",
      url: api.recentLoginData,
    });

    if (result && result.data && result.data.success) {
      setState((pre) => ({
        ...pre,
        recentData: result.data.data,
      }));
    }
  };

  return (
    <div className="col-sm-6 mt-lg-0 mt-5">
      <h6 className="text-dark poppins-400-28">Recent Logins</h6>
      {state.recentData && state.recentData.length > 0 ? (
        <div className="d-flex" style={{ gap: "15px" }}>
          {state.recentData.map((item) => {
            return (
              <div key={item._id}>
                <Card className="align-items-center">
                  <CardHeader className="bg bg-white text-end">
                    <button
                      type="button"
                      className="close bg bg-white"
                      style={{ border: "none" }}
                      aria-label="Close"
                    >
                      {/* <span aria-hidden="true" className="bg bg-white" 
                                // onClick={(e) => this.remove(e)}
                                >&times;</span> */}
                    </button>
                  </CardHeader>
                  <Avatar size={100} name={item.firstname} round />
                  {/* {item.image.length == 0 ? <img width="100%" src={image} className="img-thumbnail rounded-circle mt-n3" width="150" height="150" alt="..." />
                                : <img width="100%" src={item.image[0].location} className="img-thumbnail rounded-circle mt-n3" width="150" height="150" alt="..." />
                            } */}
                  <CardBody>
                    <CardText className="text-dark">{`${item.firstname} ${item.lastname}`}</CardText>
                  </CardBody>
                </Card>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-dark text-left mt-5 poppins-400-16">
          No recent data available
        </div>
      )}
    </div>
  );
};

export default connect(mapState, actionCreators)(withNavigate(Landing));
